module.exports = "/assets/logo_sg_creativecloud-dec69614b678cf4ea43091a280fa306e.png";